import PropTypes from 'prop-types';

const RadioOnSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 22}`}
      height={`${height || 22}`}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="4" fill={color} />
      <rect x="1" y="1" width="20" height="20" rx="10" stroke={color} />
    </svg>
  );
};

RadioOnSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default RadioOnSvg;
